import Chip from "@mui/material/Chip";
import React, { useEffect, useMemo, useState } from "react";

export default function CustomChip({ value, onOff, yesNo, activeInactive, trueFalse, opendResolved, enabledDisabled, freePaid }) {
    const [on, setOn] = useState(false);

    // Memoized labels to avoid recalculating on each render
    const { onLabel, offLabel } = useMemo(() => {
        if (onOff) return { onLabel: "On", offLabel: "Off" };
        if (yesNo) return { onLabel: "Yes", offLabel: "No" };
        if (activeInactive) return { onLabel: "Active", offLabel: "Inactive" };
        if (trueFalse) return { onLabel: "True", offLabel: "False" };
        if (opendResolved) return { onLabel: "Opened", offLabel: "Resolved" };
        if (enabledDisabled) return { onLabel: "Enabled", offLabel: "Disabled" };
        if (freePaid) return { onLabel: "Free", offLabel: "Paid" };
        return { onLabel: "", offLabel: "" };
    }, [onOff, yesNo, activeInactive, trueFalse, opendResolved, enabledDisabled, freePaid]);

    // Update `on` state based on the `value` prop
    useEffect(() => {
        if (typeof value === "string") {
            setOn(["ON", "YES", "ACTIVE", "ENABLED", "OPENED", "FREE"].includes(value.toUpperCase()));
        } else if (typeof value === "boolean") {
            setOn(value);
        }
    }, [value]);

    return (
        <>
            {on ? (
                <Chip label={onLabel} color="primary" size="small" />
            ) : (
                <Chip label={offLabel} color="warning" variant="outlined" size="small" />
            )}
        </>
    );
}
